import {
    CREATE_ISSUE_TYPE,
    RETRIEVE_ISSUE_TYPE,
    UPDATE_ISSUE_TYPE
} from "../../actions/types";

const initialState = [];

function issueTypeReducer(issueTypes = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case CREATE_ISSUE_TYPE:
            return [...issueTypes, payload];
        case RETRIEVE_ISSUE_TYPE:
            return payload;
        case UPDATE_ISSUE_TYPE:
            return issueTypes.map(issueType => {
                if (issueType.id === payload.id) {
                    return {...issueType, ...payload};
                } else {
                    return issueType;
                }
            });
        default:
            return issueTypes;
    }
}

export default issueTypeReducer;